import {suspendSite} from '@/api/admin';
import {useMutation, useQueryClient} from '@tanstack/react-query';

export function useSuspendSite() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (siteId: string) => suspendSite(siteId),
        onSuccess: () => {
            queryClient.invalidateQueries(['admin', 'sites']);
            queryClient.invalidateQueries(['admin', 'stats']);
        }
    });
}
